var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7473_24026)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89805 6.74055C1.71387 7.1503 1.71387 7.64676 1.71387 8.63969V10.8397C1.71387 12.0883 1.71387 12.7126 1.96905 13.1812C2.19048 13.5878 2.55424 13.9197 2.97935 14.103C3.46928 14.3143 4.08037 14.2582 5.30256 14.1461C6.22877 14.0611 7.19154 13.9642 7.99958 13.8645C9.06876 13.7327 10.3795 13.5305 11.5268 13.3426C12.4903 13.1849 12.972 13.106 13.3468 12.8579C13.673 12.6419 13.9406 12.327 14.101 11.9702C14.2853 11.5603 14.2853 11.0635 14.2853 10.07V7.86956C14.2853 6.62165 14.2853 5.9977 14.0302 5.52922C13.8089 5.12276 13.4452 4.79079 13.0203 4.6074C12.5306 4.39603 11.9199 4.45183 10.6986 4.56345C9.7718 4.64815 8.80822 4.74484 7.99958 4.84454C6.92981 4.97645 5.61823 5.17929 4.47042 5.36771C3.50774 5.52574 3.0264 5.60475 2.65189 5.85287C2.32587 6.06887 2.05838 6.38384 1.89805 6.74055ZM4.33291 10.8474C4.9115 10.8474 5.38053 10.3784 5.38053 9.79978C5.38053 9.22119 4.9115 8.75216 4.33291 8.75216C3.75433 8.75216 3.2853 9.22119 3.2853 9.79978C3.2853 10.3784 3.75433 10.8474 4.33291 10.8474Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24151 4.29195C2.48616 4.18252 2.73019 4.10822 2.96609 4.05036C3.31396 3.96502 3.72763 3.89715 4.16707 3.82505L4.21576 3.81706C5.36951 3.62767 6.70572 3.42077 7.80716 3.28496C8.63966 3.18231 9.62195 3.08389 10.5555 2.99857L10.6135 2.99327C11.1742 2.94198 11.6913 2.89468 12.1273 2.89292C12.6001 2.89101 13.1186 2.93835 13.6429 3.16464C13.7156 3.19603 13.7873 3.22982 13.8577 3.26589C13.7062 3.06726 13.5195 2.89422 13.311 2.76216C12.9233 2.51662 12.4311 2.45057 11.4466 2.31847C10.3919 2.17696 9.21987 2.03323 8.26131 1.95018C7.4769 1.88221 6.5436 1.82957 5.64866 1.78962C4.48877 1.73784 3.90883 1.71194 3.44028 1.93253C3.0353 2.12319 2.6873 2.456 2.47877 2.85208C2.29909 3.19334 2.25322 3.61021 2.24151 4.29195Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7473_24026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet28);
export default __webpack_public_path__ + "static/media/wallet_28.15e720e2.svg";
export { ForwardRef as ReactComponent };